var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:[_vm.circle ? 'cropper-yuan' : '']},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"id":"image","src":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }